module.exports = __webpack_public_path__ + "img/success.eff558b7.png";